import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "installments-info"
}
const _hoisted_2 = {
  "format-key": "0",
  "data-qa": "count"
}
const _hoisted_3 = {
  class: "_fw-b _whs-nw",
  "format-key": "1",
  "data-qa": "amount-to-pay"
}
const _hoisted_4 = {
  "format-key": "0",
  "data-qa": "count"
}
const _hoisted_5 = {
  class: "_fw-b _whs-nw",
  "format-key": "1",
  "data-qa": "amount-to-pay"
}
const _hoisted_6 = {
  "format-key": "0",
  "data-qa": "count"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_ctx.installmentsCount)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.isPayType)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($options.isInUpgradeMode)
                ? (_openBlock(), _createBlock(_component_localize, {
                    key: $options.formattedNewPlanAmount,
                    resource: _ctx.Resources.Checkout.CheckoutInstallmentsUpgradeDetailsInfoLabel
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.installmentsCount), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_3, _toDisplayString($options.amountToDisplay), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"]))
                : (_openBlock(), _createBlock(_component_localize, {
                    key: $options.amountToDisplay,
                    resource: _ctx.Resources.Checkout.CheckoutInstallmentsDetailsInfoLabel
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.installmentsCount), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_5, _toDisplayString($options.amountToDisplay), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"]))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createBlock(_component_localize, {
              key: _ctx.installmentsCount,
              resource: _ctx.Resources.Checkout.CheckoutInstallmentsPledgeDetailsInfoLabel
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.installmentsCount), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"]))
      ]))
    : _createCommentVNode("v-if", true)
}